module.exports = __webpack_public_path__ + "img/MCB-Off-1.24a958b2.gif";